class StickyAtc extends HTMLElement {
  connectedCallback() {
    const id = this.dataset.section;
    this.submit = document.getElementById('ProductSubmitButton-' + id);
    this.priceSource = document.getElementById('price-' + id);
    this.priceTarget = this.querySelector('[data-sticky-price]');
    this.button = this.querySelector('[data-sticky-button]');
    if (!this.submit) return;

    this.button.addEventListener('click', () => {
      if (this.submit.disabled || this.submit.getAttribute('aria-disabled') === 'true') {
        this.submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        this.submit.click();
      }
    });

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const below = entry.boundingClientRect.top < 0;
        this.hidden = !(below && !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.submit);

    this.syncPrice();
    if (this.priceSource) {
      this.mutation = new MutationObserver(() => this.syncPrice());
      this.mutation.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
    }
  }

  syncPrice() {
    if (!this.priceSource || !this.priceTarget) return;
    const el = this.priceSource.querySelector('.price-item--sale') || this.priceSource.querySelector('.price-item--regular');
    this.priceTarget.textContent = el ? el.textContent.trim() : '';
    const label = this.submit && this.submit.textContent.trim();
    if (label) this.button.textContent = label;
  }

  disconnectedCallback() {
    this.observer && this.observer.disconnect();
    this.mutation && this.mutation.disconnect();
  }
}
if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
